import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';
import { ColorScheme } from '../../Design/view/files/ImageWebsiteLogo';

export default class SiteBuilderWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  public colorMap: ColorScheme = null;

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(data: { colorMap: ColorScheme }) {
    this.colorMap = data.colorMap;
  }

  getWizardData() {
    return {
      color_map: this.colorMap
    };
  }

  getSessionKey() {
    return 'SiteBuilderWizardData';
  }
}
